/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { firstValueFrom } from "rxjs";

import { HttpClient, HttpContext } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { ApiConfiguration } from "../api-configuration";
import { BaseService } from "../base-service";
import { getCurrentUser } from "../fn/user/get-current-user";
import { GetCurrentUser$Params } from "../fn/user/get-current-user";
import { getUserConfig } from "../fn/user/get-user-config";
import { GetUserConfig$Params } from "../fn/user/get-user-config";
import { getUserSettings } from "../fn/user/get-user-settings";
import { GetUserSettings$Params } from "../fn/user/get-user-settings";
import { logError } from "../fn/user/log-error";
import { LogError$Params } from "../fn/user/log-error";
import { registerForUserInterview } from "../fn/user/register-for-user-interview";
import { RegisterForUserInterview$Params } from "../fn/user/register-for-user-interview";
import { reportDiagnostics } from "../fn/user/report-diagnostics";
import { ReportDiagnostics$Params } from "../fn/user/report-diagnostics";
import { reportDiagnostics_1 } from "../fn/user/report-diagnostics-1";
import { ReportDiagnostics_1$Params } from "../fn/user/report-diagnostics-1";
import { updateUserSettings } from "../fn/user/update-user-settings";
import { UpdateUserSettings$Params } from "../fn/user/update-user-settings";
import { User } from "../models/user";
import { UserConfig } from "../models/user-config";
import { UserSettings } from "../models/user-settings";
import { StrictHttpResponse } from "../strict-http-response";

@Injectable({ providedIn: "root" })
export class UserService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCurrentUser()` */
  static readonly GetCurrentUserPath = "/dashboard/user/me";

  /**
   * Get Current User.
   *
   * Retrieve current active User when logged in.
   *
   * Returns:
   *     User object.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCurrentUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCurrentUser$Response(params?: GetCurrentUser$Params, context?: HttpContext): Promise<StrictHttpResponse<User>> {
    const obs = getCurrentUser(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Get Current User.
   *
   * Retrieve current active User when logged in.
   *
   * Returns:
   *     User object.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCurrentUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCurrentUser(params?: GetCurrentUser$Params, context?: HttpContext): Promise<User> {
    const resp = this.getCurrentUser$Response(params, context);
    return resp.then((r: StrictHttpResponse<User>): User => r.body);
  }

  /** Path part for operation `getUserConfig()` */
  static readonly GetUserConfigPath = "/dashboard/user/config";

  /**
   * Get User Config.
   *
   * Return configuration API configuration relevant to the front-end, among which OAuth2 details.
   *
   * Returns:
   *     Dict with User configuration
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserConfig$Response(
    params?: GetUserConfig$Params,
    context?: HttpContext,
  ): Promise<StrictHttpResponse<UserConfig>> {
    const obs = getUserConfig(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Get User Config.
   *
   * Return configuration API configuration relevant to the front-end, among which OAuth2 details.
   *
   * Returns:
   *     Dict with User configuration
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserConfig(params?: GetUserConfig$Params, context?: HttpContext): Promise<UserConfig> {
    const resp = this.getUserConfig$Response(params, context);
    return resp.then((r: StrictHttpResponse<UserConfig>): UserConfig => r.body);
  }

  /** Path part for operation `logError()` */
  static readonly LogErrorPath = "/dashboard/user/error";

  /**
   * Log Error.
   *
   * Log client errors.
   *
   * Args:
   *     client_error: error to be logged
   *     current_user: current user
   *
   * Returns:
   *     HTTP ok.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `logError()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  logError$Response(params: LogError$Params, context?: HttpContext): Promise<StrictHttpResponse<any>> {
    const obs = logError(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Log Error.
   *
   * Log client errors.
   *
   * Args:
   *     client_error: error to be logged
   *     current_user: current user
   *
   * Returns:
   *     HTTP ok.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `logError$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  logError(params: LogError$Params, context?: HttpContext): Promise<any> {
    const resp = this.logError$Response(params, context);
    return resp.then((r: StrictHttpResponse<any>): any => r.body);
  }

  /** Path part for operation `getUserSettings()` */
  static readonly GetUserSettingsPath = "/dashboard/user/settings";

  /**
   * Get User Settings.
   *
   * Get the settings for the current user.
   *
   * Returns:
   *     UserSettings object for logged on persons.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserSettings()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserSettings$Response(
    params?: GetUserSettings$Params,
    context?: HttpContext,
  ): Promise<StrictHttpResponse<UserSettings>> {
    const obs = getUserSettings(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Get User Settings.
   *
   * Get the settings for the current user.
   *
   * Returns:
   *     UserSettings object for logged on persons.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserSettings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserSettings(params?: GetUserSettings$Params, context?: HttpContext): Promise<UserSettings> {
    const resp = this.getUserSettings$Response(params, context);
    return resp.then((r: StrictHttpResponse<UserSettings>): UserSettings => r.body);
  }

  /** Path part for operation `updateUserSettings()` */
  static readonly UpdateUserSettingsPath = "/dashboard/user/settings";

  /**
   * Update User Settings.
   *
   * Update user settings.
   *
   * Returns:
   *     Posted object.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUserSettings()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUserSettings$Response(
    params: UpdateUserSettings$Params,
    context?: HttpContext,
  ): Promise<StrictHttpResponse<UserSettings>> {
    const obs = updateUserSettings(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Update User Settings.
   *
   * Update user settings.
   *
   * Returns:
   *     Posted object.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUserSettings$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUserSettings(params: UpdateUserSettings$Params, context?: HttpContext): Promise<UserSettings> {
    const resp = this.updateUserSettings$Response(params, context);
    return resp.then((r: StrictHttpResponse<UserSettings>): UserSettings => r.body);
  }

  /** Path part for operation `reportDiagnostics()` */
  static readonly ReportDiagnosticsPath = "/dashboard/user/diagnostic-report/{customer_id}";

  /**
   * Report Diagnostics.
   *
   * Generate a diagnostics report.
   *
   * Use this endpoint to generate diagnostic information to accompany a support request.
   *
   * Args:
   *     payload: Diagnostic report payload (email, full name, other means of contact, issue description)
   *     customer_id: the currently active customer in NWD
   *     current_user: current user
   *     db: MongoDB client
   *
   * Returns:
   *     HTTP ok.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportDiagnostics()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportDiagnostics$Response(
    params: ReportDiagnostics$Params,
    context?: HttpContext,
  ): Promise<StrictHttpResponse<null>> {
    const obs = reportDiagnostics(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Report Diagnostics.
   *
   * Generate a diagnostics report.
   *
   * Use this endpoint to generate diagnostic information to accompany a support request.
   *
   * Args:
   *     payload: Diagnostic report payload (email, full name, other means of contact, issue description)
   *     customer_id: the currently active customer in NWD
   *     current_user: current user
   *     db: MongoDB client
   *
   * Returns:
   *     HTTP ok.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportDiagnostics$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportDiagnostics(params: ReportDiagnostics$Params, context?: HttpContext): Promise<null> {
    const resp = this.reportDiagnostics$Response(params, context);
    return resp.then((r: StrictHttpResponse<null>): null => r.body);
  }

  /** Path part for operation `reportDiagnostics_1()` */
  static readonly ReportDiagnostics_1Path = "/dashboard/user/diagnostic-report/";

  /**
   * Report Diagnostics.
   *
   * Generate a diagnostics report.
   *
   * Use this endpoint to generate diagnostic information to accompany a support request.
   *
   * Args:
   *     payload: Diagnostic report payload (email, full name, other means of contact, issue description)
   *     customer_id: the currently active customer in NWD
   *     current_user: current user
   *     db: MongoDB client
   *
   * Returns:
   *     HTTP ok.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reportDiagnostics_1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportDiagnostics_1$Response(
    params: ReportDiagnostics_1$Params,
    context?: HttpContext,
  ): Promise<StrictHttpResponse<null>> {
    const obs = reportDiagnostics_1(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Report Diagnostics.
   *
   * Generate a diagnostics report.
   *
   * Use this endpoint to generate diagnostic information to accompany a support request.
   *
   * Args:
   *     payload: Diagnostic report payload (email, full name, other means of contact, issue description)
   *     customer_id: the currently active customer in NWD
   *     current_user: current user
   *     db: MongoDB client
   *
   * Returns:
   *     HTTP ok.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reportDiagnostics_1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reportDiagnostics_1(params: ReportDiagnostics_1$Params, context?: HttpContext): Promise<null> {
    const resp = this.reportDiagnostics_1$Response(params, context);
    return resp.then((r: StrictHttpResponse<null>): null => r.body);
  }

  /** Path part for operation `registerForUserInterview()` */
  static readonly RegisterForUserInterviewPath = "/dashboard/user/interview-registration";

  /**
   * Register For User Interview.
   *
   * Communicate with the API maintainers via this endpoint.
   *
   * Args:
   *     payload: User submitted data, specifically an initial message
   *     current_user: The user profile (automatically injected)
   *     db: The database (injected)
   *
   * Returns:
   *     200 OK if completed successfully, otherwise other relevant error
   *     status codes.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `registerForUserInterview()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  registerForUserInterview$Response(
    params: RegisterForUserInterview$Params,
    context?: HttpContext,
  ): Promise<StrictHttpResponse<null>> {
    const obs = registerForUserInterview(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Register For User Interview.
   *
   * Communicate with the API maintainers via this endpoint.
   *
   * Args:
   *     payload: User submitted data, specifically an initial message
   *     current_user: The user profile (automatically injected)
   *     db: The database (injected)
   *
   * Returns:
   *     200 OK if completed successfully, otherwise other relevant error
   *     status codes.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `registerForUserInterview$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  registerForUserInterview(params: RegisterForUserInterview$Params, context?: HttpContext): Promise<null> {
    const resp = this.registerForUserInterview$Response(params, context);
    return resp.then((r: StrictHttpResponse<null>): null => r.body);
  }
}
